// TDS2 SHIM — replace with @salesforce/trailhead-ui equivalents when TDS2 lands.
// Celebratory full-panel "Agent deployed successfully!" state, shown once the
// learner completes the agent-chat hands-on challenge (ChatContainer locks the
// session). Ported from the headless-agent-creation prototype's CompletedState
// (ChatComponentsPage.tsx). Mirrors WelcomeState's centered hero layout: trophy
// mascot, "Beta Feature" tag, title, body.
//
// The share row reuses the production `<th-social-sharing>` web component (the
// same one TrailCompletedModal/BadgeSharing render), so the icon set matches our
// other completion modals. It is gated behind `showSharing`, which defaults to
// false — the wiring ships dark and can be flipped on later without component
// changes.
import React from 'react';
import PropTypes from 'prop-types';
import BetaTag from 'components/agentforce/BetaTag';

export default function DeploySuccessState({
  mascotUrl,
  title = 'Agent successfully deployed!',
  body = "You've successfully built an agent using natural language.",
  showSharing = false,
  sharing = null,
}) {
  return (
    <div className="tds2-agentforce-welcome" data-tds2-shim="DeploySuccessState">
      <div
        className="tds2-agentforce-welcome__hero tds2-agentforce-deploy-success"
        role="status"
        aria-live="polite"
      >
        {mascotUrl ? (
          <img
            src={mascotUrl}
            alt=""
            width="120"
            className="tds2-agentforce-welcome__mascot"
            aria-hidden="true"
          />
        ) : null}
        <BetaTag />
        <h2 className="tds2-agentforce-deploy-success__title">{title}</h2>
        <p className="tds2-agentforce-deploy-success__body">{body}</p>
        {/* LinkedIn does not accept share text but needs an identifier to toggle
            the button on — mirrors TrailCompletedModal.renderSharing. The share row
            is gated behind showSharing and only renders when sharing data exists. */}
        {showSharing && sharing ? (
          <div className="tds2-agentforce-deploy-success__share">
            <th-social-sharing
              app-id={sharing.fbAppId}
              content-title={sharing.contentTitle}
              content-description={sharing.contentDescription}
              public={true}
              facebook-text={sharing.shareText}
              x-text={sharing.shareText}
              linkedin-text={'toggle'}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

DeploySuccessState.propTypes = {
  mascotUrl: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  // Gates the social-share row. Defaults to false so the row stays hidden until
  // product turns sharing on; the wiring below is ready when it flips.
  showSharing: PropTypes.bool,
  // Only consumed when showSharing is true. Mirrors the sharing data shape used
  // by the completion modals (fbAppId + content title/description + share text).
  sharing: PropTypes.shape({
    fbAppId: PropTypes.string,
    contentTitle: PropTypes.string,
    contentDescription: PropTypes.string,
    shareText: PropTypes.string,
  }),
};
